import { ButtonComponent } from '@/components/commons'
import { InputComponent } from '@/components/commons/forms/input/Input.component'
import { Text } from '@/components/commons/typography/Text'
import { Title } from '@/components/commons/typography/Title'
import { Drawer } from '@/components/modal/Drawer'
import { SearchIcon } from '@/public/assets/v2/images/icons'
import { cssClass } from '@/shared/utils'
import { useMemo, useState } from 'react'

interface TagsSelectorModalProps {
  openModal: boolean
  title: string
  description: string
  withSearch?: boolean
  tagList: string[]
  selectedTags: string[]
  toggleTag: (tag: string) => void
  closeDrawer: () => void
}

export const TagsSelectorModal = ({
  openModal,
  closeDrawer,
  title,
  description,
  withSearch = false,
  tagList = [],
  selectedTags = [],
  toggleTag,
}: TagsSelectorModalProps) => {
  const [search, setSearch] = useState('')

  const filteredTags = useMemo(() => {
    if (!search) {
      return tagList
    }
    return tagList.filter((tag) =>
      tag.toLowerCase().includes(search.toLocaleLowerCase())
    )
  }, [search, tagList])

  const isTagSelected = (tag: string) => {
    return selectedTags.includes(tag)
  }

  const close = () => {
    setSearch('')
    closeDrawer()
  }

  return (
    <Drawer
      opened={openModal}
      onClose={close}
      closeOnClickOutside={false}
      closeOnEscape={false}
      size="md"
      position="right"
      className="--v2"
      style={{
        zIndex: 10000016,
      }}
      styles={{
        overlay: {
          zIndex: 10000016,
        },
        inner: {
          zIndex: 10000017,
        },
        content: {
          zIndex: 10000018,
        },
      }}
    >
      <div className="px-10">
        <Title sizeClass="text-18">{title}</Title>
        <Text sizeClass="text-14">{description}</Text>
        {withSearch && (
          <div className="pt-20">
            <InputComponent
              size="small"
              usePlaceholder={true}
              placeholder="Quick Search"
              value={search}
              onChange={(e) => setSearch(e.currentTarget.value)}
              iconLeft={<SearchIcon className="text-secondary text-14" />}
            />
          </div>
        )}
        <div className="flex gap-8 wrap mt-20">
          {filteredTags?.map((tag) => (
            <div
              onClick={() => toggleTag(tag)}
              key={tag + '_modal'}
              className={cssClass([
                'flex gap-8 py-4 px-8 items-center rounded-6 cursor-pointer',
                isTagSelected(tag)
                  ? 'bg-accent-tertiary-lighter'
                  : 'bg-tertiary',
              ])}
            >
              <Text
                sizeClass="text-13"
                colorClass={isTagSelected(tag) ? 'text-info' : 'text-primary'}
              >
                {tag}
              </Text>
            </div>
          ))}
        </div>

        <div className="full-w flex justify-flex-end">
          <ButtonComponent
            size="xSmall"
            className="mt-30"
            label="Ok"
            onClick={close}
          />
        </div>
      </div>
    </Drawer>
  )
}
